import { DOWNLOAD_APP_POPUP_CONFIG } from '../Config/Config';

const MS_PER_DAY = 24 * 60 * 60 * 1000;

const shouldShowDownloadAppPopup = () => {
  if (!DOWNLOAD_APP_POPUP_CONFIG.enabled) {
    return false;
  }

  try {
    const dismissedAt = localStorage.getItem(
      DOWNLOAD_APP_POPUP_CONFIG.localStorageKey
    );
    if (!dismissedAt) {
      return true;
    }

    const daysSinceDismissed =
      (Date.now() - Number(dismissedAt)) / MS_PER_DAY;
    return daysSinceDismissed >= DOWNLOAD_APP_POPUP_CONFIG.reappearAfterDays;
  } catch (error) {
    return true;
  }
};

const markDownloadAppPopupDismissed = () => {
  try {
    localStorage.setItem(
      DOWNLOAD_APP_POPUP_CONFIG.localStorageKey,
      Date.now().toString()
    );
  } catch (error) {
    // localStorage indisponible (navigation privée, quota, etc.) : on ignore silencieusement
  }
};

export { shouldShowDownloadAppPopup, markDownloadAppPopupDismissed };
